import { useState, useEffect } from 'react';

/**
 * Debounce a rapidly-changing value.
 *
 * Returns a copy of `value` that only updates after `delay` ms have elapsed
 * without a further change. Used by the global command palette and the
 * per-list search inputs (Fas 11) so filtering/rendering does not run on
 * every keystroke.
 *
 * @param {*} value - The value to debounce (typically a search string).
 * @param {number} [delay=200] - Idle time in ms before the value propagates.
 * @returns {*} The debounced copy of `value`.
 */
export default function useDebounce(value, delay = 200) {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(id);
  }, [value, delay]);

  return debounced;
}
